import { useDeviceType } from "@hook/useDeviceType";
import { HeaderDesktop } from "./HeaderDesktop";
import { HeaderMobile } from "./HeaderMobile";

interface IProps {
    cartItemsNumber?: number;
    logoutCallback?(): void;
}

export const Header = (props: IProps) => {
    const { cartItemsNumber, logoutCallback } = props;
    const { isDesktop } = useDeviceType();

    if (isDesktop) {
        return <HeaderDesktop cartItemsNumber={cartItemsNumber} logoutCallback={logoutCallback} />;
    }

    return <HeaderMobile cartItemsNumber={cartItemsNumber} logoutCallback={logoutCallback} />;
};
